import { Injectable } from '@angular/core';
import { BaseService } from '@app/shared/services/base.service';
import { HttpClient } from '@angular/common/http';
import { User } from '@app/core/models';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseService {
  rolesAllowedForCosts = ['Admin', 'Super Admin'];

  constructor(http: HttpClient) {
    super('users', http);
  }

  // Role names are compared case-insensitively so a stored 'Admin'/'ADMIN'
  // matches regardless of how the backend cased it.
  isUserInRole(user: User, roleName: string): boolean {
    const target = roleName.toLowerCase();
    return Array.isArray(user.roleNames)
      ? user.roleNames.some((userRole) => userRole?.toLowerCase() === target)
      : (user.roleNames as unknown as string)?.toLowerCase() === target;
  }

  isUserInRoleArray(user: User, roleNames: string[]): boolean {
    const targets = roleNames.map((r) => r.toLowerCase());
    const userRole = user?.roleNames as unknown as string;
    return Array.isArray(user?.roleNames)
      ? user.roleNames.some((role) => targets.includes(role?.toLowerCase()))
      : targets.includes(userRole?.toLowerCase());
  }
}
